var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { addRs2fHash, parseAsync as parse } from '../parsing/parse';
import { resolveFilterSource } from './filterSource';
var stringifyErrors = function (errors) {
    return errors.map(function (e) { return e.message; }).join('\n');
};
export var loadFilterFromUrl = function (url, revision) { return __awaiter(void 0, void 0, void 0, function () {
    var resolved, _a, response, filterText, start, _b, errors, filter, end;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!(revision !== null && revision !== void 0)) return [3 /*break*/, 1];
                _a = revision;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, resolveFilterSource(url)];
            case 2:
                _a = (_c.sent());
                _c.label = 3;
            case 3:
                resolved = _a;
                if (!['http:', 'https:'].includes(new URL(resolved.revisionUrl).protocol)) {
                    throw new Error('Filter revision must be an HTTP or HTTPS URL');
                }
                return [4 /*yield*/, fetch(resolved.revisionUrl)];
            case 4:
                response = _c.sent();
                if (!response.ok)
                    throw new Error("Failed to load filter (".concat(response.status, ")"));
                return [4 /*yield*/, response.text()];
            case 5:
                filterText = _c.sent();
                start = new Date().getTime();
                return [4 /*yield*/, parse(filterText, true)];
            case 6:
                _b = _c.sent(), errors = _b.errors, filter = _b.filter;
                end = new Date().getTime();
                if (errors && errors.length > 0) {
                    throw Error('Failed to parse filter: ' +
                        stringifyErrors(errors));
                }
                if (filter == null) {
                    throw Error('This should be impossible');
                }
                console.log("parsed \"".concat(filter.name, "\" in"), end - start, 'ms');
                filter.source = url;
                filter.commit = resolved.commit;
                filter.revisionUrl = resolved.revisionUrl;
                return [2 /*return*/, addRs2fHash(filter)];
        }
    });
}); };
